export enum FileType {
  PDF = 'pdf2',
  XLS = 'xls2',
}
